import React from 'react';

const OrderContext = React.createContext({});

export default OrderContext;